module.exports = __webpack_public_path__ + "6e8b7e0f9425ef4cf2722b9df94bf206.svg";